/* eslint-disable radix */
import { useEffect } from 'react';

import { S3_PMTILES_URL } from '@constants/s3.constants';
import { useSelector } from 'react-redux';
import { useUploadedBuildingFeatureCollection } from '../../../utils/queries/upload.queries';

function BuildingsLayer({ map, opacity, selectedValue }) {
  const currentBaseMapStyle = useSelector(state => state.maplibreMap.currentBaseMapStyle)
  const { data: selectedFeatureCollection } = useUploadedBuildingFeatureCollection(selectedValue)

  useEffect(() => {
    if (map && !map.getLayer('buildings')) {
      if (selectedFeatureCollection && selectedFeatureCollection?.length > 0) {
        map.addSource('buildings', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: selectedFeatureCollection,
          },
        });
        map.addLayer({
          id: 'buildings',
          type: 'fill',
          source: 'buildings',
          paint: {
            'fill-color': 'rgba(2, 39, 65, 0.8)',
            'fill-outline-color': '#777',
          },
        }, 'z-index-3');
      } else {
        map.addSource('buildings', {
          type: 'vector',
          url: `pmtiles://${S3_PMTILES_URL}/buildings.pmtiles`,
        });
        map.addLayer({
          id: 'buildings',
          type: 'fill',
          source: 'buildings',
          'source-layer': 'buildings',
          paint: {
            'fill-color': 'rgba(2, 39, 65, 0.8)',
            'fill-outline-color': '#777',
          },
        }, 'z-index-3');
      }
    }
  
    return () => {
      if (map && !map._removed) {
        if (map.getLayer('buildings')) {
          map.removeLayer('buildings');
        }
      
        if (map.getSource('buildings')) {
          map.removeSource('buildings');
        }
      }
    };
  }, [map, currentBaseMapStyle, selectedFeatureCollection]);

  useEffect(() => {
    if (map) {
      map.setPaintProperty('buildings', 'fill-opacity', opacity);
    }
  }, [map, opacity]);

  return null;
}

export default BuildingsLayer;